import React from 'react';
import ReactDOM from 'react-dom/client';
import '@tabler/core/dist/css/tabler.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@tabler/core/dist/js/tabler.min.js';
import './theme.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);
